import React, {useState, useEffect, useSearchParams} from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

import { LoadingButton } from "@mui/lab";
import { Checkbox, FormControlLabel, TextField, Autocomplete } from "@mui/material";


import AddEquipmentRow from "../../components/AddEquipmentRow"
import AddEquipmentModal from "../../components/AddEquipmentModal"

import { getAllSites, getBuildingsForSite, getBuildingSpaces, getSiteEquipment, addEquipment, addProduct, getSiteZones } from "../../services/MetadataService";
import { getBrickEquipmentTypes, getEquipmentSystems } from "../../services/DimensionsServices";
import { getProducts, addProductToAirtable } from "../../services/ProductGuideService";

const AddEquipmentForm = (props) => {
    let [sites, setSites] = useState()
    let [buildings, setBuildings] = useState([])
    let [spaces, setSpaces] = useState([])
    let [zones, setZones] = useState([])
    let [existingEquipment, setExistingEquipment] = useState([])

    let [selectedSite, setSelectedSite] = useState() //TODO: Default these when called from other pages
    let [selectedBuilding, setSelectedBuilding] = useState()
    let [selectedSpace, setSelectedSpace] = useState()
    let [selectedZone, setSelectedZone] = useState()

    let [selectedType, setSelectedType] = useState()
    let [selectedSystem, setSelectedSystem] = useState()

    let [brickTypes, setBrickTypes] = useState([])
    let [systems, setSystems] = useState([])
    let [products, setProducts] = useState([])

    let [rows, setRows] = useState(1)
    let [equipment, setEquipment] = useState({})
    let [successCount, setSuccessCount] = useState(0)

    let [openModal, setOpenModal] = useState(false)
    let [isSubmitting, setIsSubmitting] = useState(false)

    let [elementId, setElementId] = useState()
    
    let history = useHistory();

    useEffect(() => {
        if (brickTypes.length == 0) {
            getBrickEquipmentTypes().then(response => {
                setBrickTypes(response)
            });    
        }

        if (systems.length == 0) {
            getEquipmentSystems().then(response => {
                setSystems(response)
            })
        }

        if (products.length == 0) {
            getProducts().then(response => {
                let products = [];
                response.forEach (r => {
                    products.push({
                        id: r.product_id,
                        label: r.company === "Unknown" ? "Unknown" : r.company + " " + r.model
                    })
                })
                products.sort((a, b) => (a.label > b.label) ? 1 : -1)
                setProducts(products)
            })
        }

        let siteId = props.siteId || (selectedSite && selectedSite.site_id)
        if (siteId) {
            getSiteEquipment(siteId).then(response => {
                setExistingEquipment(response)
            })
        }

        if (!sites) {
            getAllSites(false).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSites(response)
                if (props.siteId) {
                    let site = response.find(s => s.site_id == parseInt(props.siteId))
                    setSelectedSite(site)
                }
            })
        }
    },[])

    useEffect(() => {
        if (selectedSite) {
             getSiteEquipment(selectedSite.site_id).then(response => {
                 setExistingEquipment(response)
            })

            getBuildingsForSite(selectedSite.site_id).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setBuildings(response)
                if (props.buildingId) {
                    let building = response.find(b => b.id == parseInt(props.buildingId))
                    setSelectedBuilding(building)
                }
            })

            getSiteZones(selectedSite.site_id).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setZones(response)
                if (props.zoneId) {
                    let zone = response.find(b => b.id == parseInt(props.zoneId))
                    setSelectedZone(zone)
                }
            })


        }

    },[selectedSite])

    useEffect(() => {
        if (selectedBuilding) {
            getBuildingSpaces(selectedBuilding.id).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSpaces(response)

                let space = response.find(b => b.id == parseInt(props.spaceId))
                setSelectedSpace(space)
            })
        }

    },[selectedBuilding])

    useEffect(() => {
        let element_id = selectedSpace && selectedSpace.id ? "space_" + selectedSpace.id  : 
            selectedZone && selectedZone.id ? "zone_" + selectedZone.id :
            selectedBuilding && selectedBuilding.id ? "building_" + selectedBuilding.id :
            selectedSite && "site_" + selectedSite.site_id

        setElementId(element_id)
        console.log("Element id is: " + element_id)

    },[selectedSite, selectedBuilding, selectedZone, selectedSpace])

    const equipmentToAddCallback = (id, newEquipment) => {
        let currentEquipment = Object.assign({}, equipment)
        if (newEquipment.success) return;

        newEquipment.success = null
        newEquipment.error = null

        let existingEq = existingEquipment && existingEquipment.find(s => s.name === newEquipment.name)
        console.log(existingEq)
        if (existingEq) newEquipment.error = "Equipment with this name already exists for the current site."

        let addingEquipment = Object.keys(equipment).find(index => index != id && equipment[index].name === newEquipment.name)
        if (addingEquipment) newEquipment.error = "You have already added this equipment."


        currentEquipment[id] = newEquipment;
        setEquipment(currentEquipment)
    }

    const submitAll = async () => {
        Object.keys(equipment).forEach(i => {
            setIsSubmitting(true)
            let e = equipment[i]
            if (e.name && e.type) {
                if (e.product && e.product.id) {
                    e.product_id = e.product.id
                    e.product = null
                    addEquipment(e).then(response => {
                        let currentEquipment = Object.assign([], equipment)
                        currentEquipment[i].success = true
                        currentEquipment[i].error = null
                        setSuccessCount(successCount + 1)
                        setEquipment(currentEquipment)
                        setIsSubmitting(false)
                        return true;
                    }).catch(err => {
                        let currentEquipment = Object.assign([], equipment)
                        currentEquipment[i].success = false
                        currentEquipment[i].error = "Failed to add equipment"
                        setEquipment(currentEquipment)
                        setIsSubmitting(false)
                        return false;
                    })
                } else if (e.product && e.product.company && e.product.model) {
                    addProductToAirtable(e.product).then(productId => {
                        e.product_id = productId
                        e.product.product_id = productId
                        addProduct(e.product).then(() => {
                            addEquipment(e).then(response => {
                                let currentEquipment = Object.assign([], equipment)
                                currentEquipment[i] = response
                                currentEquipment[i].success = true
                                currentEquipment[i].error = null
                                setSuccessCount(successCount + 1)
                                setEquipment(currentEquipment)
                                setIsSubmitting(false)
                                return true;
                            }).catch(err => {
                                let currentEquipment = Object.assign([], equipment)
                                currentEquipment[i].success = false
                                currentEquipment[i].error = "Failed to add equipment"
                                setEquipment(currentEquipment)
                                setIsSubmitting(false)
                                return false;
                            })
                        })
                    })
                    
                } else {
                    addEquipment(e).then(response => {
                        let currentEquipment = Object.assign([], equipment)
                        currentEquipment[i] = response
                        currentEquipment[i].success = true
                        currentEquipment[i].error = null
                        setSuccessCount(successCount + 1)
                        setEquipment(currentEquipment)
                        setIsSubmitting(false)
                        return true;
                    }).catch(err => {
                        let currentEquipment = Object.assign([], equipment)
                        currentEquipment[i].success = false
                        currentEquipment[i].error = "Failed to add equipment"
                        setEquipment(currentEquipment)
                        setIsSubmitting(false)
                        return false;
                    })
                }
            } 

        })

    }

    if (!sites) return null;

    if (successCount === rows && rows == 1) {
        history.push("/equipment/" + equipment[0].equipment_id)
    } else if (successCount === rows && rows != 0) {
        let returnURL = selectedSpace ? "/spaces/" + selectedSpace.id:
                        selectedZone ? "/zones/" + selectedZone.id :
                        selectedBuilding ? "/buildings/" + selectedBuilding.id :
                        selectedSite ? "/sites/" + selectedSite.site_id : "/"
                        
        history.push(returnURL)
    }
    
    let addRows = [];
    if (elementId) {
        for (let i = 0; i < rows; i++) {
            let rowEquipment = equipment && equipment[i] || {};
            let key = elementId + i
            addRows.push(
                <AddEquipmentRow key={key} row_num={i} callback={equipmentToAddCallback} equipmentTypes={brickTypes} systems={systems} products={products} equipment={rowEquipment} elementId={elementId} />
            )
        }
    }

    let location = selectedSpace && selectedSpace.name ? "the space '" + selectedSpace.name + "'" : 
                selectedZone && selectedZone.name ? "zone '" + selectedZone.name + "'":
                selectedBuilding && selectedBuilding.name ? "the building '" + selectedBuilding.name + "'":
                selectedSite && selectedSite.name

    console.log("Location is " + location)

    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width < 1200) {
        return (
            <AddEquipmentModal
                open={true}
                equipmentToAddCallback={equipmentToAddCallback} 
                brickTypes={brickTypes} 
                systems={systems} 
                products={products} 
                equipment={equipment && equipment[0] || {}} 
                elementId={elementId}
                location={location}
                handleSubmit={submitAll}
                closeCallback={() => {setOpenModal(false)}}
            />
        )
    }

    return (
        <div className="layer3">
            <div className="bulk-add-form">
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="sites"
                        options={sites}
                        getOptionLabel={option => option.name}
                        value={sites.find(s => s.site_id == props.siteId)}
                        size="small"
                        renderInput={(params) => <TextField {...params} label="Site" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSite(newValue);
                            setSelectedBuilding(null);
                            setSelectedZone(null);
                            setSelectedSpace(null);
                        }}
                    />
                </div>

                {
                zones && zones.length > 0 ?
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="zones"
                        size="small"
                        options={zones}
                        getOptionLabel={option => option.name}
                        value={zones.find(b => b.id == props.zoneId)}
                        renderInput={(params) => <TextField {...params} label="Zone" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedZone(newValue);
                            setSelectedBuilding(null);
                            setSelectedSpace(null);
                        }}
                    />
                </div> : null
            }


            {
                buildings && buildings.length > 0 ?
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="buildings"
                        size="small"
                        options={buildings}
                        getOptionLabel={option => option.name}
                        value={buildings.find(b => b.id == props.buildingId)}
                        renderInput={(params) => <TextField {...params} label="Building" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedBuilding(newValue);
                            setSelectedSpace(null);
                        }}
                    />
                </div> : null
            }

            {
                !selectedZone && spaces && spaces.length > 0 ?
                <div className="form-field">
                    <Autocomplete
                        disablePortal
                        id="spaces"
                        size="small"
                        options={spaces}
                        value={spaces.find(s => s.id == props.spaceId)}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => <TextField {...params} label="Space" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSpace(newValue);
                        }}
                    />
                </div> : null
            }

            {
                selectedSite ?
                <div className="add-container">
                    <div className="instructions">You may add equipment to the site generally (in cases such as a PV array), a building (often for rooftop units), a space (room), or a zone.  You are currently entering equipment for {location}:</div>
                    {
                        addRows
                    }
                   
                    <div className="form-buttons">
                        <div className="form-button-left" onClick={() => {setRows(rows+1)}}>Add Row</div>
                        <LoadingButton
                            variant="contained"
                            loading={isSubmitting}
                            type="submit"
                            onClick={submitAll}
                            sx={{position: "absolute", right: 0, backgroundColor: "#003e51"}}>
                                Submit
                        </LoadingButton>
                    </div>
                </div> : null
            }

            </div>
        </div>

    )


}

export default AddEquipmentForm;